// 前端可选语言（含中文）；中文仅手动切换，不参与 IP/注册地区自动切换
// 自动切换仍按后端 support_langs() 的 8 种语言；不属于这 8 种的国家/地区，后端统一返回 en_us
export const LANGS = [
  { code: 'en_us', name: 'English',    flag: '🇺🇸' },
  { code: 'es_spa', name: 'Español',   flag: '🇪🇸' },
  { code: 'fr',    name: 'Français',   flag: '🇫🇷' },
  { code: 'de',    name: 'Deutsch',    flag: '🇩🇪' },
  { code: 'it',    name: 'Italiano',   flag: '🇮🇹' },
  { code: 'nl',    name: 'Nederlands', flag: '🇳🇱' },
  { code: 'pt',    name: 'Português',  flag: '🇵🇹' },
  { code: 'pl',    name: 'Polski',     flag: '🇵🇱' },
  { code: 'zh_cn', name: '中文',       flag: '🇨🇳' }, // 仅前端手动切，不自动切
];

export const SUPPORT_LANGS = LANGS.map(item => item.code);

// 参与 IP / 注册地区自动切换的语言（排除中文）
export const AUTO_LANGS = SUPPORT_LANGS.filter(code => code !== 'zh_cn');

export function langName(code) {
  const hit = LANGS.find(item => item.code === code);
  return hit ? hit.name : 'English';
}

// 是否用户手动切过语言（手动优先，不再被 IP / 注册地区覆盖）
export const LANG_MANUAL_KEY = 'lang_manual';

export function setLangManual() {
  localStorage.setItem(LANG_MANUAL_KEY, '1');
}
